var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "boss-main-content-wrap" },
    [
      _vm.isCompanyStaffAccess
        ? _c("setting-header", {
            staticClass: "hide-for-print",
            attrs: {
              breadcrumbs: [
                { name: "求人確認" },
                _vm.isPrePublishedAccess
                  ? { name: "掲載前の求人", pathName: "jobPrePublished" }
                  : {
                      name: "掲載済みの求人・応募フォームタイプ設定",
                      pathName: "jobPublished",
                    },
              ],
              title: _vm.isPrePublishedAccess
                ? "掲載前の求人プレビュー_検索一覧"
                : "掲載済みの求人プレビュー_検索一覧",
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "pega-search-result-wrap" },
        [
          _c(
            "div",
            { staticClass: "grid-x hide-for-print" },
            [
              _c(
                "div",
                { staticClass: "cell auto" },
                [
                  _c("sp-preview-button", {
                    attrs: {
                      id: Number(_vm.id),
                      "route-name": _vm.spRouteNameForJobSearch,
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("print-button", { staticClass: "cell shrink" }),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "pega-text-small" }, [
            _vm._v(
              "\n      ※「インタビュー」「フォトクリップ」は掲載時ご利用の場合のみ表示されます。\n    "
            ),
          ]),
          _vm._v(" "),
          _c("job-search-preview-detail", {
            attrs: {
              "job-search-result": _vm.jobSearchResult,
              "photo-data": _vm.jobSearchResult.mainPhoto,
              "employment-status": _vm.jobSearchResult.employmentStatus,
              "pr-codes": _vm.jobSearchResult.prCodes,
              report: _vm.jobSearchResult.report,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }